import React, { useContext, useEffect } from 'react'
import { MainContext } from '../contexts/MainContext'

const NotFound = (props) => {
  const { isTengo, getServiceStyles } = useContext(MainContext);

  useEffect(() => {
    if (!isTengo && window.location.hostname && window.location.hostname !== 'localhost') {
      
      window.location= 'https://cobru.co'
    }
  }, [isTengo])

  if (isTengo) {
    return (
      <main className="flex h-screen items-center justify-center flex-col gap-4 text-center px-6">
        <img src={getServiceStyles().logo} alt="Tengo" className="w-32" />
        <p>Enlace de pago no encontrado</p>
      </main>
    )
  }
  
  return (
    <div>NotFound</div>
  )
}

export default NotFound
